import { SortingState } from "@tanstack/react-table";
import { QUERY_PARAMS_KEYS } from "../../consts";
import { SORT_DIRECTIONS } from "./consts";

export const rowIdsToExpandedState = (expandedRowsIds: string[]) =>
  expandedRowsIds.reduce<Record<string, true>>((acc, row) => {
    acc[row] = true;

    return acc;
  }, {});

export const getInitialSortingState = (
  searchParams: URLSearchParams,
  tableColumnToSortColumnMap: Record<string, string>,
  initialSortingState: SortingState,
) => {
  const sortBy = searchParams.get(QUERY_PARAMS_KEYS.SORT_BY);
  const sortDirection = searchParams.get(QUERY_PARAMS_KEYS.SORT_DIRECTION);

  if (
    !sortBy ||
    !sortDirection ||
    !tableColumnToSortColumnMap[sortBy] ||
    !SORT_DIRECTIONS[sortDirection as "DESC" | "ASC"]
  ) {
    return initialSortingState;
  }

  return [{ id: sortBy, desc: sortDirection === SORT_DIRECTIONS.DESC }];
};
